export const isSafePrice = (value) => Number.isInteger(value) && value > 0 && value < 1e5;
